export default "__VITE_ASSET__938eb24b__"